import type { AppNotificationRecord } from '@/types/notifications'

function normalizeLegacyUrl(url: string): string {
  // Old exchange notifications used /exchanges/ before the route was renamed to /payouts/
  if (url.startsWith('/exchanges/')) {
    return '/payouts' + url.slice('/exchanges'.length)
  }
  if (url === '/exchanges') {
    return '/payouts'
  }
  return url
}

export function resolveNotificationActionUrl(item: AppNotificationRecord): string | null {
  const metadata = item.metadata ?? {}
  const event = (metadata.event as string) ?? ''

  // If backend already provides an action_url, use it directly (with legacy normalization)
  if (metadata.action_url && typeof metadata.action_url === 'string') {
    return normalizeLegacyUrl(metadata.action_url)
  }

  switch (event) {
    case 'agent_invited':
      return metadata.activation_url && typeof metadata.activation_url === 'string'
        ? metadata.activation_url
        : null

    case 'agent_activation':
      return '/dashboard'

    case 'agent_suspended':
    case 'agent_reactivated':
      return metadata.agent_id && typeof metadata.agent_id === 'string'
        ? `/agents/${metadata.agent_id}`
        : null

    case 'program_assigned':
    case 'program_unassigned':
    case 'program_activated':
    case 'program_paused':
    case 'program_resumed':
    case 'program_suspended':
    case 'program_rewards_updated':
    case 'program_archived':
      return metadata.program_id && typeof metadata.program_id === 'string'
        ? `/programs/${metadata.program_id}`
        : null

    case 'business_invited':
      return metadata.activation_url && typeof metadata.activation_url === 'string'
        ? metadata.activation_url
        : null

    case 'business_approved':
    case 'business_rejected':
      return '/dashboard'

    case 'prospect_submitted':
    case 'prospect_submitted_public':
    case 'prospect_status_changed':
    case 'prospect_converted':
    case 'prospect_lost':
      return metadata.prospect_id && typeof metadata.prospect_id === 'string'
        ? `/prospects/${metadata.prospect_id}`
        : null

    case 'transaction_detected':
    case 'transaction_validated':
    case 'transaction_paid':
      return metadata.transaction_id && typeof metadata.transaction_id === 'string'
        ? `/transactions/${metadata.transaction_id}`
        : null

    case 'points_earned':
      return '/transactions'

    case 'exchange_requested':
    case 'exchange_approved':
    case 'exchange_rejected':
    case 'exchange_processing':
    case 'exchange_completed':
    case 'exchange_cancelled':
      return metadata.exchange_id && typeof metadata.exchange_id === 'string'
        ? `/payouts/${metadata.exchange_id}`
        : null

    case 'sync_job_failed':
    case 'sync_job_dead_lettered':
      return '/settings?tab=api'

    default:
      return null
  }
}
